<script setup lang="ts">
  withDefaults(defineProps<{ spanLeft?: number; spanRight?: number }>(), {
    spanLeft: 3,
    spanRight: 9,
  });
</script>

<template>
  <div class="grid w-full grid-cols-12 gap-4">
    <div
      class="self-stretch"
      :style="spanLeft ? { gridColumn: `span ${spanLeft}` } : { display: 'none' }">
      <slot name="left" />
    </div>
    <div :style="spanRight ? { gridColumn: `span ${spanRight}` } : { display: 'none' }">
      <slot name="right" />
    </div>
  </div>
</template>
